import { awaitablePromise } from '@isyc-react/core/utils';
export const awaitableApollo = promise => awaitablePromise(promise);